import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { removeMultipleLocation } from "slices/locationSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { Link } from "react-router-dom";
import { usePermissions } from "layouts/Admin";
import { fetchLocationsListPage } from "slices/locationSlice";
import { locationSelector } from "slices/locationSlice";
import { changeStatus } from "slices/locationSlice";
import OptionsMenu from "components/OptionsMenu";
const apiService = new Api();

function LocationList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions()
  const { location, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(locationSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}
  });
  const refAddutton = React.useRef(null);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });


  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchLocationsListPage(page));
  }, [])
  React.useEffect(() => {
    dispatch(fetchLocationsListPage())
  }, [])

  const handleAddTypePopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchLocationsListPage())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const handleRemoveItems = React.useCallback(() => {
    dispatch(removeMultipleLocation({ ids: selectedItems }, submitCallback))
  }, [selectedItems])

  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(location.map((type) => type.id.toString()))
  }



  const renderTableHeader = React.useCallback(() => {

    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchLocationsListPage(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }

    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Client Account') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th>
          <TableHeaderItem
            title="Location Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Address"
            sortBy="address"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Email"
            sortBy="email"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Contact Name"
            sortBy="contact_name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Phone Number"
            sortBy="contact_number"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Client Account') &&
          <th>Status</th>
        }
        {checkPermission('Edit Client Account') &&
          <th>Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, location])


  const renderTableContent = React.useCallback(() => {
    return (
      location?.map((type, index) => {
        return <LocationItems type={type} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddTypePopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      })
    )
  }, [location, selectedItems, current_page]);

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  return (
    <ListLayout
      title="Locations"
      buttonTitle="Add Location"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchLocationsListPage}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      addformModal={false}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddTypePopUp}
      searchTerm={searchTerm}
      sortConfig={sortConfig}
      loader={loader}
      searchPlaceholder="Search location ..."
      noOfItems={total}
      disableBootstrap={true}
      renderAddLink={(callback) => checkPermission('Add Locations') && <Link to="/locations/create" className="main_button ml-4"><img src="/images/plus.png" alt="" /> Add Location</Link>}
      setSearchTerm={setSearchTerm}
    >
      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}

const LocationItems = ({
  type, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(type?.user?.status == 1 ? 1 : 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));
  }
  React.useEffect(() => {
    setStatus(type?.user?.status == 1 ? 1 : 0 || 0)
  }, [type])
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Client Account') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={type.id} checked={selectedItems.includes(type.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.user?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.address || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.user?.email || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.contact_name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.contact_number || 'N/A'}
      </td>

      {checkPermission('Status Client Account') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(type?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      <td style={getBackgroundStyle(status)}>
        <OptionsMenu
          options={[
            checkPermission('View Departments') && (
              <Link to={`/locations/departments/${type?.id}`} className="drop_menu">Departments</Link>
            ),
            checkPermission('View Facilities') && (
              <Link to={`/locations/facilities/${type?.id}`} className="drop_menu">Facilities</Link>
            ),
            checkPermission('Edit Locations') && (
              <Link to={`/locations/update/${type?.id}`} className="drop_menu">
                <img src="/images/edit-button.png" alt="" style={{ width: 16, marginRight: 5 }} />
                Edit
              </Link>
            ),
          ].filter(Boolean)}
        />
      </td>
    </tr>
  )
}

export default LocationList;